import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=6e4e38bc&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&id=6e4e38bc&prod&lang=scss&"
import style1 from "./comment.vue?vue&type=style&index=1&id=6e4e38bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4e38bc",
  null
  
)

export default component.exports